import {StackLayout} from "@progress/kendo-react-layout";
import {useLayoutEffect, useState} from "react";
import BankNotificationGrid from "./BankNotificationGrid";

const BankNotifications = props => {

    const menuSize = props.menuSize
    const [refSize, setRefSize] = useState({width: 0, height: 0});

    const handleSize = () => {
        let width = window.innerWidth - 10;
        const height = window.innerHeight;
        setRefSize({
            width: width,
            height: height
        })
    }

    useLayoutEffect(() => {
        handleSize()
        window.addEventListener("resize", handleSize);
        return () => window.removeEventListener("resize", handleSize);
    }, []);

    return (
        <>
            <StackLayout
                style={{
                    height: "calc(100vh - 55px)",
                }}
                orientation={"vertical"}
                gap={0}
            >
                <BankNotificationGrid size={refSize} menuSize={menuSize} />
            </StackLayout>
        </>
    )
}

export default BankNotifications
